
import { Button } from '@/components/ui/button';
import { useRSVP } from '../context/RSVPContext';
import { RSVPFlowState } from '../types';
import { ArrowLeft, ArrowRight } from 'lucide-react';

interface RSVPNavigationProps {
  currentState: RSVPFlowState;
}

export const RSVPNavigation = ({ currentState }: RSVPNavigationProps) => {
  // Always return null to remove the navigation footer
  return null;
};
